import { useTranslation } from 'react-i18next'

import { BuildingSelect } from '../../../../Building'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { useInitiallyOpenSelect } from '../../../../Select'
import {
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_PLACEHOLDER_KEYS,
} from '../../RequestEditApplicantAddressModal.constants'

function RequestEditApplicantAddressModalBuildingField({
  autoFocus,
  buildingApiParams,
  required,
  onChange,
  onClear,
}) {
  const { t } = useTranslation()

  const selectStatesRef = useInitiallyOpenSelect(autoFocus)

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={BuildingSelect}
      apiParams={buildingApiParams}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder: t(
              REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_PLACEHOLDER_KEYS[
                REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING
              ]
            ),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: t(
          REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS[
            REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING
          ]
        ),
        required,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING}
      selectStatesRef={selectStatesRef}
      onChange={onChange}
      onClear={onClear}
    />
  )
}

export default RequestEditApplicantAddressModalBuildingField
